import React from "react";
import HeroSection from "../components/HeroSection"; // Import HeroSection

export default function AboutPage() {
    return (
        <section className="about-page section">
            <div className="content-wrapper">
                {/* Header */}
                <h2 className="section-title">Tentang Kami</h2>

                {/* Content */}
                <div className="slide active">
                    <div>
                        <p>
                            PT. Innovatech Digi Eravision adalah perusahaan yang bergerak di bidang sistem integrasi IT, Audio Visual, dan Automation, berfokus pada penyediaan solusi teknologi yang terintegrasi dan disesuaikan dengan kebutuhan klien. Kami tidak hanya menawarkan perangkat product berkualitas tinggi, tetapi juga memberikan pengalaman yang menyeluruh dengan <span className="highlight">desain interior 3 dimensi</span> yang membantu klien memvisualisasikan implementasi perangkat tersebut yang akan digunakan.
                        </p>
                        <p>
                            Salah satu keunggulan utama kami adalah <span className="highlight">desain interior 3 dimensi</span>. Kami memberikan solusi desain yang memungkinkan klien melihat visualisasi dari implementasi perangkat product yang diinginkan sebelum proses instalasi dimulai. Dengan menggunakan desain 3D, klien dapat lebih mudah membuat keputusan dan merasakan bagaimana perangkat akan terintegrasi dengan estetika ruang.
                        </p>
                    </div>
                </div>
            </div>
        </section>
    );
}